/**
 * State Configuration Data
 * 
 * Contains configuration for all US states and DC including:
 * - State code (2-letter abbreviation)
 * - Full state name
 * - URL slug for navigation
 * - Official lottery website URL
 * - Status (active, coming_soon, no_data)
 * 
 * Active states: IL, FL, PA, DC, CT, TX, ID, IA
 * Coming soon: 35 states from STATE_LOTTERY_DISCLAIMER_URLS.md
 * No data: AL, HI, ND, UT, WY, NV, AK (not in disclaimer file)
 */

export const STATE_CONFIG = {
  // Active States (8)
  IL: {
    code: 'IL',
    name: 'Illinois',
    slug: 'illinois',
    url: 'https://www.illinoislottery.com/',
    status: 'active'
  },
  FL: {
    code: 'FL',
    name: 'Florida',
    slug: 'florida',
    url: 'https://floridalottery.com',
    status: 'active'
  },
  PA: {
    code: 'PA',
    name: 'Pennsylvania',
    slug: 'pennsylvania',
    url: 'https://www.palottery.pa.gov/scratch-offs/prizes-remaining.aspx',
    status: 'active'
  },

  // Coming Soon States (35)
  AZ: {
    code: 'AZ',
    name: 'Arizona',
    slug: 'arizona',
    url: 'https://www.arizonalottery.com/scratchers/',
    status: 'coming_soon'
  },
  AR: {
    code: 'AR',
    name: 'Arkansas',
    slug: 'arkansas',
    url: 'https://myarkansaslottery.com/games/instant',
    status: 'coming_soon'
  },
  CA: {
    code: 'CA',
    name: 'California',
    slug: 'california',
    url: 'https://www.calottery.com/en/scratchers',
    status: 'coming_soon'
  },
  CO: {
    code: 'CO',
    name: 'Colorado',
    slug: 'colorado',
    url: 'https://www.coloradolottery.com/en/games/scratch/',
    status: 'coming_soon'
  },
  CT: {
    code: 'CT',
    name: 'Connecticut',
    slug: 'connecticut',
    url: 'https://www.ctlottery.org/scratchgames',
    status: 'active'
  },
  DE: {
    code: 'DE',
    name: 'Delaware',
    slug: 'delaware',
    url: 'https://www.delottery.com',
    status: 'coming_soon'
  },
  DC: {
    code: 'DC',
    name: 'Washington D.C.',
    slug: 'dc',
    url: 'https://dclottery.com/dc-scratchers',
    status: 'active'
  },
  GA: {
    code: 'GA',
    name: 'Georgia',
    slug: 'georgia',
    url: 'https://www.galottery.com',
    status: 'coming_soon'
  },
  ID: {
    code: 'ID',
    name: 'Idaho',
    slug: 'idaho',
    url: 'https://www.idaholottery.com/games/scratch?view=remaining_prizes',
    status: 'active'
  },
  IN: {
    code: 'IN',
    name: 'Indiana',
    slug: 'indiana',
    url: 'https://www.hoosierlottery.com/games/scratch-off/scratch-off-stats/',
    status: 'coming_soon'
  },
  IA: {
    code: 'IA',
    name: 'Iowa',
    slug: 'iowa',
    url: 'https://www.ialottery.com/Pages/Games/RemainingPrizes.aspx',
    status: 'active'
  },
  KS: {
    code: 'KS',
    name: 'Kansas',
    slug: 'kansas',
    url: 'https://www.kslottery.com/instantgameslist',
    status: 'coming_soon'
  },
  KY: {
    code: 'KY',
    name: 'Kentucky',
    slug: 'kentucky',
    url: 'https://www.kylottery.com/apps/scratch_offs/prizes_remaining.html',
    status: 'coming_soon'
  },
  LA: {
    code: 'LA',
    name: 'Louisiana',
    slug: 'louisiana',
    url: 'https://louisianalottery.com/top-prizes-remaining',
    status: 'coming_soon'
  },
  ME: {
    code: 'ME',
    name: 'Maine',
    slug: 'maine',
    url: 'https://www.mainelottery.com/players_info/unclaimed_prizes.html',
    status: 'coming_soon'
  },
  MD: {
    code: 'MD',
    name: 'Maryland',
    slug: 'maryland',
    url: 'https://www.mdlottery.com/games/scratch-offs/',
    status: 'coming_soon'
  },
  MA: {
    code: 'MA',
    name: 'Massachusetts',
    slug: 'massachusetts',
    url: 'https://www.masslottery.com/tools/prizes-remaining',
    status: 'coming_soon'
  },
  MI: {
    code: 'MI',
    name: 'Michigan',
    slug: 'michigan',
    url: 'https://www.michiganlottery.com/resources/instant-games-prizes-remaining',
    status: 'coming_soon'
  },
  MN: {
    code: 'MN',
    name: 'Minnesota',
    slug: 'minnesota',
    url: 'https://www.mnlottery.com/games/unclaimed-prizes',
    status: 'coming_soon'
  },
  MS: {
    code: 'MS',
    name: 'Mississippi',
    slug: 'mississippi',
    url: 'https://www.mslottery.com/gamestatus/active',
    status: 'coming_soon'
  },
  MO: {
    code: 'MO',
    name: 'Missouri',
    slug: 'missouri',
    url: 'https://www.molottery.com/scratchers-list.do',
    status: 'coming_soon'
  },
  MT: {
    code: 'MT',
    name: 'Montana',
    slug: 'montana',
    url: 'https://montanalottery.com/scratch-games',
    status: 'coming_soon'
  },
  NE: {
    code: 'NE',
    name: 'Nebraska',
    slug: 'nebraska',
    url: 'https://nelottery.com/homeapp/scratch/prizesremaining/web',
    status: 'coming_soon'
  },
  NH: {
    code: 'NH',
    name: 'New Hampshire',
    slug: 'new-hampshire',
    url: 'https://www.nhlottery.com/prizes/prizes-remaining',
    status: 'coming_soon'
  },
  NJ: {
    code: 'NJ',
    name: 'New Jersey',
    slug: 'new-jersey',
    url: 'https://www.njlottery.com/en-us/scratch-offs.html',
    status: 'coming_soon'
  },
  NM: {
    code: 'NM',
    name: 'New Mexico',
    slug: 'new-mexico',
    url: 'https://www.nmlottery.com/games/scratchers/top-prizes-not-yet-claimed',
    status: 'coming_soon'
  },
  NY: {
    code: 'NY',
    name: 'New York',
    slug: 'new-york',
    url: 'https://nylottery.ny.gov/scratch-off-games',
    status: 'coming_soon'
  },
  NC: {
    code: 'NC',
    name: 'North Carolina',
    slug: 'north-carolina',
    url: 'https://nclottery.com/scratch-off-prizes-remaining',
    status: 'coming_soon'
  },
  OH: {
    code: 'OH',
    name: 'Ohio',
    slug: 'ohio',
    url: 'https://www.ohiolottery.com/games/scratch-offs/prizes-remaining',
    status: 'coming_soon'
  },
  OK: {
    code: 'OK',
    name: 'Oklahoma',
    slug: 'oklahoma',
    url: 'https://www.lottery.ok.gov/scratchers/remaining-prizes',
    status: 'coming_soon'
  },
  OR: {
    code: 'OR',
    name: 'Oregon',
    slug: 'oregon',
    url: 'https://www.oregonlottery.org/scratch-its/list',
    status: 'coming_soon'
  },
  RI: {
    code: 'RI',
    name: 'Rhode Island',
    slug: 'rhode-island',
    url: 'https://www.rilot.com/en-us/instantgames.html',
    status: 'coming_soon'
  },
  SC: {
    code: 'SC',
    name: 'South Carolina',
    slug: 'south-carolina',
    url: 'https://www.sceducationlottery.com/Games/PrizesRemaining',
    status: 'coming_soon'
  },
  SD: {
    code: 'SD',
    name: 'South Dakota',
    slug: 'south-dakota',
    url: 'https://lottery.sd.gov/games/scratch-games/',
    status: 'coming_soon'
  },
  TN: {
    code: 'TN',
    name: 'Tennessee',
    slug: 'tennessee',
    url: 'https://tnlottery.com/games/instant-games/',
    status: 'coming_soon'
  },
  TX: {
    code: 'TX',
    name: 'Texas',
    slug: 'texas',
    url: 'https://www.texaslottery.com/export/sites/lottery/Games/Scratch_Offs/all.html',
    status: 'active'
  },
  VT: {
    code: 'VT',
    name: 'Vermont',
    slug: 'vermont',
    url: 'https://vtlottery.com/games/instant-tickets/outstanding-prizes',
    status: 'coming_soon'
  },
  VA: {
    code: 'VA',
    name: 'Virginia',
    slug: 'virginia',
    url: 'https://www.valottery.com/scratcher-search',
    status: 'coming_soon'
  },
  WA: {
    code: 'WA',
    name: 'Washington',
    slug: 'washington',
    url: 'https://walottery.com/Scratch/TopPrizesRemaining.aspx',
    status: 'coming_soon'
  },
  WV: {
    code: 'WV',
    name: 'West Virginia',
    slug: 'west-virginia',
    url: 'https://wvlottery.com/games/scratch-offs',
    status: 'coming_soon'
  },
  WI: {
    code: 'WI',
    name: 'Wisconsin',
    slug: 'wisconsin',
    url: 'https://wilottery.com/games/instant-games/scratch-games',
    status: 'coming_soon'
  },

  // No Data States (7)
  AL: {
    code: 'AL',
    name: 'Alabama',
    slug: null,
    url: null,
    status: 'no_data'
  },
  AK: {
    code: 'AK',
    name: 'Alaska',
    slug: null,
    url: null,
    status: 'no_data'
  },
  HI: {
    code: 'HI',
    name: 'Hawaii',
    slug: null,
    url: null,
    status: 'no_data'
  },
  ND: {
    code: 'ND',
    name: 'North Dakota',
    slug: null,
    url: null,
    status: 'no_data'
  },
  NV: {
    code: 'NV',
    name: 'Nevada',
    slug: null,
    url: null,
    status: 'no_data'
  },
  UT: {
    code: 'UT',
    name: 'Utah',
    slug: null,
    url: null,
    status: 'no_data'
  },
  WY: {
    code: 'WY',
    name: 'Wyoming',
    slug: null,
    url: null,
    status: 'no_data'
  }
};

/**
 * Get all state codes
 * @returns {string[]} Array of state codes
 */
export function getAllStateCodes() {
  return Object.keys(STATE_CONFIG);
}

/**
 * Get states by status
 * @param {string} status - Status to filter by ('active', 'coming_soon', 'no_data')
 * @returns {Object[]} Array of state configurations
 */
export function getStatesByStatus(status) {
  return Object.values(STATE_CONFIG).filter(state => state.status === status);
}
